<template>
  <CCol cols="6" xl="6" lg="6" md="6" sm="12" class="latest posts">
    <CCard class="leaderboard mb-0 h-100">
      <CCardHeader class="pb-0">
        {{$t('loyalty.Leaderboard_moments_sent')}}
      </CCardHeader>
      <CCardBody class="has_tabs pb-0">
        <CRow>     
          <CCol cols="12" class="p-0">
            <b-tabs class="points_leaderboard no_borders mb-0"
                    type="is-boxed"
                    :animated="false"
                    v-model="activeTab"
                    @input="currentPage = 1;"
                    v-bind:class="{'remove_bottom_content_padding' : (activeTab === 0 && !momentsSentLastMonthPaginated) || (activeTab === 1 && !momentsSentLastThreeMonthsPaginated) || (activeTab === 2 && !momentsSentLastYearPaginated)}">
            
              <b-tab-item>
                <template slot="header">
                  <span>{{ $t('loyalty.Moments_sent') }} - {{ $t('common.last_30_days')}}</span>
                </template>
                <template>
                  <CRow>
                    <CCol cols="12" lg="12" class="p-0">
                      <loadingSpinner mode="auto" v-if="loadingData" :content="$t('common.Loading')"/>
                      <b-table v-else
                               class="data_table"
                               :data="momentsSentLastMonth"
                               :striped="true"
                               :hoverable="true"
                               :mobile-cards="true"
                               :paginated="momentsSentLastMonthPaginated"
                               :per-page="perPage"
                               :current-page.sync="currentPage"
                               :pagination-simple="isPaginationSimple"
                               :pagination-position="paginationPosition">
                        
                        <template slot-scope="props">
                          <b-table-column field="position" width="5%">
                            <b>#{{props.row.position}}</b>
                          </b-table-column>
                          <b-table-column field="name" :label="$t('common.Name')" width="45%">
                            <div class="d-flex align-items-center">
                              <userProfilePopover ref="userProfilePopover"
                                                  mode="user" 
                                                  :userName="props.row.name"
                                                  :userProfileImage="props.row.profile_image" 
                                                  :userIdExternal="props.row.user_id_external"
                                                  :senderIdExternal="null"
                                                  popoverPlacement="right"
                                                  :triggerAvatarSize="25"
                                                  class="mr-2">
                              </userProfilePopover>
                              <div>
                                <span>{{props.row.name}}</span>
                                <span class="d-block mt-1 meta">{{props.row.team_name}} - {{props.row.department_name}}</span>
                              </div>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_moments" :label="$t('loyalty.Moments_sent')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-icon/common/spark.png/' + clientToken"/>
                              <span>{{props.row.total_moments}} {{props.row.total_moments !== 1 ? $t('sm.Sparks') : $t('sm.Spark')}}</span>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_points_spent" :label="$t('loyalty.Coins_granted')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                              <span>{{props.row.total_points_spent}} {{props.row.total_points_spent !== 1 ? $t('common.coins') : $t('common.coin')}}</span>
                            </div>                            
                          </b-table-column>                          
                        </template>
                        <template slot="empty">
                          <div class="text-center">
                            <span>{{ $t('sm.No_sparks_sent_yet') }}</span>
                          </div>
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </b-tab-item>
              <b-tab-item>
                <template slot="header">
                  <span>{{ $t('loyalty.Moments_sent') }} - {{ $t('common.last_90_days')}}</span>
                </template>
                <template>
                  <CRow>
                    <CCol cols="12" lg="12" class="p-0">
                      <loadingSpinner mode="auto" v-if="loadingData" :content="$t('common.Loading')"/>
                      <b-table v-else 
                               class="data_table"
                               :data="momentsSentLastThreeMonths"
                               :striped="true"
                               :hoverable="true"
                               :mobile-cards="true"
                               :paginated="momentsSentLastThreeMonthsPaginated"
                               :per-page="perPage"
                               :current-page.sync="currentPage"
                               :pagination-simple="isPaginationSimple"
                               :pagination-position="paginationPosition">
                        
                        <template slot-scope="props">
                          <b-table-column field="position" width="5%">
                            <b>#{{props.row.position}}</b>
                          </b-table-column>
                          <b-table-column field="name" :label="$t('common.Name')" width="45%">
                            <div class="d-flex align-items-center">
                              <userProfilePopover ref="userProfilePopover"
                                                  mode="user" 
                                                  :userName="props.row.name"
                                                  :userProfileImage="props.row.profile_image" 
                                                  :userIdExternal="props.row.user_id_external"
                                                  :senderIdExternal="null"
                                                  popoverPlacement="right"
                                                  :triggerAvatarSize="25"
                                                  class="mr-2">
                              </userProfilePopover>
                              <div>
                                <span>{{props.row.name}}</span>
                                <span class="d-block mt-1 meta">{{props.row.team_name}} - {{props.row.department_name}}</span>
                              </div>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_moments" :label="$t('loyalty.Moments_sent')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-icon/common/spark.png/' + clientToken"/>
                              <span>{{props.row.total_moments}} {{props.row.total_moments !== 1 ? $t('sm.Sparks') : $t('sm.Spark')}}</span>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_points_spent" :label="$t('loyalty.Coins_granted')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                              <span>{{props.row.total_points_spent}} {{props.row.total_points_spent !== 1 ? $t('common.coins') : $t('common.coin')}}</span>
                            </div>                            
                          </b-table-column>                          
                        </template>
                        <template slot="empty">
                          <div class="text-center">
                            <span>{{ $t('sm.No_sparks_sent_yet') }}</span>
                          </div>
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </b-tab-item>
              <b-tab-item>
                <template slot="header">
                  <span>{{ $t('loyalty.Moments_sent') }} - {{ $t('common.last_365_days')}}</span>
                </template>
                <template>
                  <CRow>
                    <CCol cols="12" lg="12" class="p-0">
                      <loadingSpinner mode="auto" v-if="loadingData" :content="$t('common.Loading')"/>
                      <b-table v-else
                               class="data_table"
                               :data="momentsSentLastYear"
                               :striped="true"
                               :hoverable="true"
                               :mobile-cards="true"
                               :paginated="momentsSentLastYearPaginated"
                               :per-page="perPage"
                               :current-page.sync="currentPage"
                               :pagination-simple="isPaginationSimple"
                               :pagination-position="paginationPosition">
                        
                        <template slot-scope="props">
                          <b-table-column field="position" width="5%">
                            <b>#{{props.row.position}}</b>
                          </b-table-column>
                          <b-table-column field="name" :label="$t('common.Name')" width="45%">
                            <div class="d-flex align-items-center">
                              <userProfilePopover ref="userProfilePopover"
                                                  mode="user" 
                                                  :userName="props.row.name"
                                                  :userProfileImage="props.row.profile_image" 
                                                  :userIdExternal="props.row.user_id_external"
                                                  :senderIdExternal="null"
                                                  popoverPlacement="right"
                                                  :triggerAvatarSize="25"
                                                  class="mr-2">
                              </userProfilePopover>
                              <div>
                                <span>{{props.row.name}}</span>
                                <span class="d-block mt-1 meta">{{props.row.team_name}} - {{props.row.department_name}}</span>
                              </div>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_moments" :label="$t('loyalty.Moments_sent')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-icon/common/spark.png/' + clientToken"/>
                              <span>{{props.row.total_moments}} {{props.row.total_moments !== 1 ? $t('sm.Sparks') : $t('sm.Spark')}}</span>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_points_spent" :label="$t('loyalty.Coins_granted')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                              <span>{{props.row.total_points_spent}} {{props.row.total_points_spent !== 1 ? $t('common.coins') : $t('common.coin')}}</span>
                            </div>                            
                          </b-table-column>                          
                        </template>
                        <template slot="empty">
                          <div class="text-center">
                            <span>{{ $t('sm.No_sparks_sent_yet') }}</span>
                          </div>
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </b-tab-item>
            </b-tabs>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import axios from 'axios'
import userProfilePopover from '@/components/common/userProfilePopover.vue';
import loadingSpinner from '@/components/common/loadingSpinner.vue'

export default {
  name: 'MomentsSentLeaderboard',
  components: {
    userProfilePopover,
    loadingSpinner
  },  
  data() {
    return {
      apiBaseUrl: null,
      clientToken: null,
      environmentTag: null,
      loadingData: false,
      activeTab: 0,
      momentsSentLastMonth: [],
      momentsSentLastMonthPaginated: false,
      momentsSentLastThreeMonths: [],
      momentsSentLastThreeMonthsPaginated: false,
      momentsSentLastYear: [],
      momentsSentLastYearPaginated: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 5,      
    }
  },
  methods: {
    getMomentSentLeaderboard() {
      // Start the loader
      this.loadingData = true;
      // Get the points      
      axios.get(process.env.VUE_APP_API_URL + '/v1/insights/loyalty/leaderboard/moments/sent')
      .then(res => {
        this.momentsSentLastMonth = res.data.data.moments_sent_last_month;
        this.momentsSentLastThreeMonths = res.data.data.moments_sent_last_three_months;
        this.momentsSentLastYear = res.data.data.moments_sent_last_year;
        // Check if the pagination should be activated
        (this.momentsSentLastMonth.length > this.perPage) ? this.momentsSentLastMonthPaginated = true : this.momentsSentLastMonthPaginated = false;
        (this.momentsSentLastThreeMonths.length > this.perPage) ? this.momentsSentLastThreeMonthsPaginated = true : this.momentsSentLastThreeMonthsPaginated = false;
        (this.momentsSentLastYear.length > this.perPage) ? this.momentsSentLastYearPaginated = true : this.momentsSentLastYearPaginated = false;
        // Close the loader
        this.loadingData = false;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    showInsights(path) {
      this.$router.push({path: 'insights/' + path});
    }
  },
  mounted: function(){
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.clientToken = localStorage.getItem('token');
    if(localStorage.getItem('environmentTag') !== null) this.environmentTag = localStorage.getItem('environmentTag');

    this.getMomentSentLeaderboard();
  }
}
</script>